export default __webpack_public_path__ + "static/media/search-empty.65c39624.svg";